import { render, staticRenderFns } from "./GroupCustomerAccountCreation.vue?vue&type=template&id=58936958&"
import script from "./GroupCustomerAccountCreation.vue?vue&type=script&lang=js&"
export * from "./GroupCustomerAccountCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports